<template>
    <div>
        <b-row v-show="show_pdf == false">
            <b-col v-if="isNewDocument" cols="12">
                <b-card>
                    <b-alert :show="true" variant="light">Add a document title</b-alert>
                </b-card>
            </b-col>
            <b-col cols="12" v-if="isNewDocument == false">
                <b-card class="revisions-bar">
                    <span class="roundIcon" :style="revision.published == 1 ? 'color: #05B15F !important;':''" style="font-size: 1.8rem;" v-for="(revision, index) in sop_revisions" @click="selectRevision(index)" :key="index" :title="revision.published == 1 ? 'Published' : 'Draft'" >
                        <!--<i v-if="index != 0" class="fas fa-minus"></i>-->
                        <span v-if="index != 0">-</span>
                        <i v-if="isRevisionSelected(index)" class="fas fa-check-circle"></i>
                        <i v-else class="fas fa-circle"></i><!-- v-if="index == selected_revision_index" -->
                    </span>
                    <div v-if="hasSops">
                        <b-alert class="m-0" :show="true">
                            No Revision History
                        </b-alert>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="10" v-if="isNewDocument == false">
                <b-card no-body class="p-1">
                    <!-- -- -- -- -->
                    <div v-if="edit_section != null && !isActiveGroup('attachments_annexures')">
                        <b-row>
                            <b-col cols="12" class="mt-2 pt-1">
                                <div class="d-flex ps-3 pe-3 pb-2 ">
                                    <div class="card-title" for="">Section Title:</div>
                                    <b-form-input size="lg" v-if="sections != null" v-model="sections[edit_section].section_title">

                                    </b-form-input>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <EditorWrapper v-if="finishedLoading && isEditableSection" @updatedSection="updateSectionText" :type="edit_section" :readOnly="isNewDocument" :text="display_data" :revision="client_sop_data.client_revisions[selected_revision_index]"/>

                    <Attachments v-if="finishedLoading && !isEditableSection" />

                </b-card>
            </b-col>
            <b-col cols="2">
                <div class="card">
                    <div style="text-align: center;" class="card-heading-text bg-green card-text p-2 mb-0">
                        HEADINGS
                        <i style="position:relative; float:right; font-size:14px;" @click="edit_section = null;" v-if="edit_section != null" class="fa fa-times"></i>
                    </div>
                    <b-overlay :show="isLoading">
                        <b-list-group class="headings-list">
                            <!-- isActiveGroup -->
                            <b-list-group-item :active="isActiveGroup('list_of_abbreviations')" @click="editHeading('list_of_abbreviations')">LIST OF ABBREVIATIONS</b-list-group-item>
                            <b-list-group-item :active="isActiveGroup('objective')" @click="editHeading('objective')">1. Objective</b-list-group-item>
                            <b-list-group-item :active="isActiveGroup('scope')" @click="editHeading('scope')">2. Scope</b-list-group-item>
                            <b-list-group-item :active="isActiveGroup('responsibility')" @click="editHeading('responsibility')">3. Responsibility</b-list-group-item>
                            <b-list-group-item :active="isActiveGroup('policy')" @click="editHeading('policy')">4. Policy</b-list-group-item>
                            <b-list-group-item :active="isActiveGroup('procedure')" @click="editHeading('procedure')">5. Procedure</b-list-group-item>
                            <b-list-group-item :active="isActiveGroup('attachments_annexures')" @click="editHeading('attachments_annexures')">6. Attachments & Annexures</b-list-group-item>
                        </b-list-group>
                    </b-overlay>
                    <b-collapse v-model="showCollpase" class="p-2">
                        <b-button @click="edit_section = null;" style="width: 100%;">Clear Selection</b-button>
                    </b-collapse>
                </div>
                
                <div v-if="isNewDocument">
                    <div @click="saveNewSopType" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Save Draft</p>
                    </div>
                    <div class="save-btn mt-3 p-2">
                        <p class="inner-btn">Continue</p>
                    </div>
                </div>
                <div v-else>
                    <div @click="saveRevision()" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Save</p>
                    </div>

                    <div @click="showPreview" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Preview</p>
                    </div>

                    <!--
                    <div @click="showApprovePrompt" class="approve-btn mt-3 p-2">
                        <p class="inner-btn">Approve</p>
                    </div>
                    -->

                </div>
            </b-col>
        </b-row>

        <b-row v-if="show_pdf">
            <b-col cols="12">
                <div class="">
                    <b-overlay style="min-height: 15rem;" :show="is_loading_pdf">
                        <b-button variant="primary" @click="show_pdf = false; b64 = null;">Close</b-button>
                        <div v-if="b64 != null" >
                            <iframe :src="'data:application/pdf;base64,' + b64" style="width: 100%; height: 80vh;"></iframe>
                        </div>
                    </b-overlay>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { sopAdminState, sopAdminMethods} from '@/state/helpers.js'
import _ from 'lodash';
import EditorWrapper from './editor-wrapper.vue'
import Attachments from './attachment-editor.vue'

import Swal from 'sweetalert2'

import {layoutMethods} from '@/state/helpers';
export default {
    /*props:{
        isNewDocument:{}
    },*/
    components:{
        EditorWrapper,
        Attachments,
    },
    data:() => ({
        //* replaced the prop
        isNewDocument: false,

        isPublishing: false,
        show_pdf: false,
        is_loading_pdf: false,
        b64: null,

        finishedLoading: false,
        edit_item: null,
        edit_section: null,
        isLoading: false,
        revision_data: null,
        selected_revision_index: null,
        section_names: [
            ['list_of_abbreviations', ''],
            ['objective', ''],
            ['scope', ''],
            ['responsibility', ''],
            ['policy', ''],
            ['procedure', ''],
            ['attachments_annexures', '']],
        sections:{
            list_of_abbreviations:{type: 'list_of_abbreviations', body: 'empty', section_title: 'test', content_height: ''},
            objective:{type: 'objective', body: 'empty', section_title: 'test', content_height: ''},
            scope:{type: 'scope', body: 'empty', section_title: 'test', content_height: ''},
            responsibility:{type: 'responsibility', body: 'empty', section_title: 'test', content_height: ''},
            policy:{type: 'policy', body: 'empty', section_title: 'test', content_height: ''},
            procedure:{type: 'procedure', body: 'empty', section_title: 'test', content_height: ''},
            attachments_annexures:{type: 'attachments_annexures', body: 'empty', section_title: 'test', content_height: ''},
        },

        document_details:{
            title: '',

        }
    }),
    computed:{
        ...sopAdminState,
        hasSops(){
            console.log(this.sop_revisions);
            if(this.sop_revisions != null){
                if(this.sop_revisions.length < 0){
                    return true;
                }
            }
            return false;
        },
        sop_revisions(){
            if(this.client_sop_data != null){
                return this.client_sop_data.client_revisions;
            }
            else{
                return [];
            }
        },
        display_data(){
            let data = '';
            if(this.edit_section == null){
                data = this.full_document;
            }
            else{
                //data = this.document_data[this.edit_section].body
                data = this.sections[this.edit_section].body
            }
            return data;
        },
        full_document(){
            //* create full document bu inserting each sections TITLE and BODY
            let doc = '';
            this.section_names.forEach( (section, i) =>{
                //* add title index - excluding abbreviations title
                let idx = '';
                if(i > 0){
                    idx = `${i}. `;
                }

                //* Exclude attachments
                if(i != 6){
                    let name = section[0];
                    doc += `<h1>${idx}${this.sections[name].section_title}</h1>`
                    doc += this.sections[name].body;
                }
            })
            return doc;
        },
        document_data(){
            return {
                abbreviation:{
                    type: 'abbreviation',
                    body: '<p></p>',
                    section_title: 'test',
                    content_height: ''
                },
                objective:{
                    type: 'objective',
                    body: '<p></p>',
                    section_title: 'test',
                    content_height: ''
                },
                scope:{
                    type: 'scope',
                    body: '<p></p>',
                    section_title: 'test',
                    content_height: ''
                },
                responsibility:{
                    type: 'responsibility',
                    body: '<p></p>',
                    section_title: 'test',
                    content_height: ''
                },
                policy:{
                    type: 'policy',
                    body: '<p></p>',
                    section_title: 'test',
                    content_height: ''
                },
                procedure:{
                    type: 'procedure',
                    body: '<p></p>',
                    section_title: 'test',
                    content_height: ''
                },
                attachment:{
                    type: 'attachment',
                    body: '<p></p>',
                    section_title: 'test',
                    content_height: ''
                },
            };
        },
        isEditableSection(){
            let valid = false;
            if(this.edit_section != "attachments_annexures"){
                valid = true;
            }
            return valid;
        },
        showCollpase:{
            get:function(){
                return this.edit_section != null;
            },
            set:function(){
                console.log('Collpase menu toggle')
            }
        },

    },
    methods:{
        ...sopAdminMethods,
        ...layoutMethods,
        editHeading(type){
            //this.isLoading = true;
            setTimeout(()=>{
                //this.isLoading = false;
            }, 1000);
            this.$nextTick(()=>{
                this.edit_section = type;
            })
        },
        selectRevision(index){
            //this.edit_section = null;
            this.revision_data = _.cloneDeep(this.sop_revisions[index]);
            this.selected_revision_index = index;
            
            //* Extract sections from array
            this.$nextTick(()=>{
                this.section_names.forEach( section => {
                    let name = section[0];
                    let body = section[1];

                    let index = _.findIndex(this.revision_data.sections, {section_id: name});
                    if(index != -1){

                        this.sections[name] = {
                            type: name,
                            body: this.revision_data.sections[index].body,
                            section_title: this.revision_data.sections[index].section_title,
                            content_height: this.revision_data.sections[index].content_height,
                        }
                    }
                    else{
                        this.sections[name] = {
                            type: name,
                            body: body,
                            section_title: '',
                            content_height: 0,
                        }
                    }
                });


                this.finishedLoading = true;
                this.$nextTick(()=>{
                    //this.setSopDisplayData(); -- old dumb way --
                    //*emit revision data to edit-documents left menu component
                    let payload = {
                        title: this.client_sop_data.name,
                        author: this.sop_revisions[this.selected_revision_index].last_edit_user_name,
                        issue_date: this.sop_revisions[this.selected_revision_index].created_at,
                        revision: this.sop_revisions[this.selected_revision_index].revision_no,
                    }
                    this.$eventHub.$emit('updatedRevisionData', payload);
                })
            })
        },
        updateSectionText(data){
            if(this.edit_section != null){
                //todo - add sweet alert popup if changes were made
                //this.has_made_changes = true
                this.sections[this.edit_section].body = data.text;
                this.sections[this.edit_section].content_height = data.height;
            }
        },
        isSelected(type){
            if(type === this.edit_section){
                return 'font-weight: bold;'
            }
            else{
                return '';
            }
        },
        isActiveGroup(type){
            if(type === this.edit_section){
                return true;
            }
            else{
                return false;
            }
        },
        isRevisionSelected(index){
            let valid = false;
            if(index == this.selected_revision_index){
                valid = true;
            }
            return valid;
        },
        showPreview(){
            this.show_pdf = true;
            this.is_loading_pdf = true;

            let params = {
                client_revision_id: this.revision_data.client_revision_id,
            }
            this.previewSop(params)
            .then((response)=>{
                this.b64 = response.b64;
                this.is_loading_pdf = false;
            })
            .catch(()=>{
                this.is_loading_pdf = false;
            });
        },
        
        showApprovePrompt() {
            console.log(this.revision_data)
            if(this.revision_data.published == 'fruit'){
                Swal.fire({
                    title: "This revision is already published.",
                    text: "",
                    icon: "info",
                    showCancelButton: false,
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "OK",
                });
            }
            else{
                Swal.fire({
                    title: "Approve this revision?",
                    text: "",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes",
                }).then((result) => {
                    if (result.value) {
                        this.approveRevision();
                    }
                });
            }
        },
        saveRevision(id = null){
            let sop_type_id = id;

            if(id == null){
                sop_type_id = this.client_sop_data.id
            }
            let params = {
                sop_type_id: sop_type_id,
                client_id: this.revision_data.client_id,
                sections:[
                    {
                        section_id: 'list_of_abbreviations',
                        section_order: 1,
                        body: '<p></p>',
                        section_title: '',
                        content_height: '',
                    },
                    {
                        section_id: 'objective',
                        section_order: 2,
                        body: '<p></p>',
                        section_title: '',
                        content_height: '',
                    },
                    {
                        section_id: 'scope',
                        section_order: 3,
                        body: '<p></p>',
                        section_title: '',
                        content_height: '',
                    },
                    {
                        section_id: 'responsibility',
                        section_order: 4,
                        body: '<p></p>',
                        section_title: '',
                        content_height: '',
                    },
                    {
                        section_id: 'policy',
                        section_order: 5,
                        body: '<p></p>',
                        section_title: '',
                        content_height: '',
                    },
                    {
                        section_id: 'procedure',
                        section_order: 6,
                        body: '<p></p>',
                        section_title: '',
                        content_height: '',
                    },
                    /*{ //* removed attachments section
                        section_id: 'attachments_annexures',
                        section_order: 7,
                        body: '<p></p>',
                        section_title: '',
                        content_height: '',
                    }*/
                ]
            }

            params.sections.forEach((item)=>{
                item.body = this.sections[item.section_id].body;
                if(item.body === ""){
                    item.body = "<p></p>"
                }
                item['content_height'] = this.sections[item.section_id].content_height;
                item.section_title = this.sections[item.section_id].section_title;
            })

            if(id != null){
                params.sections = [];
            }

            this.saveClientSopRevision(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Revision saved!',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    //timer: 2000, timerProgressBar: true
                });
                /*if(id == null){
                    //* only load  if the sop_data object exists
                    this.loadSopData(this.sop_data.id)
                    .then(()=>{
                        let idx = this.sop_data.client_revisions.length -1;
                        this.selectRevision(idx);

                    })
                }*/

            })
        },
    },
    mounted(){
        if(this.sop_revisions.length > 0){
            this.selectRevision(this.sop_revisions.length - 1);
        }
    },
}
</script>

<style>

</style>